<template>
  <div>
    <div class="mgt-20px columns">
      <div class="column is-10" v-if="this.utilisateur">
        <div class="card" id="collaborateur">
          <header class="header-card">
            <p>{{ $t('detailUtilisateur.collaborateur') }}</p>
          </header>
          <div class="card-content">
            <article class="media">
              <figure class="media-left">
                <avatar :username="getUsername"
                        :size="100" :src="logo">
                </avatar>
              </figure>
              <div class="media-content">
                <div class="content">
            <span class="has-text-default is-size-7">
              {{ getCiviliteLibelle }}
            </span>
                  <p class="title">
                    {{ (this.utilisateur.prenom === null ? '' : this.utilisateur.prenom) + ' ' +
                  this.utilisateur.nom }} </p>
                  <span class="has-text-default is-size-7">
                    {{ $t(getPosteLibelle(utilisateur.profil)) }}
                  </span>
                  <span class="has-text-default is-size-7" v-if="utilisateur.regieExterne">
                    {{ $t('detailUtilisateur.regieExterne') }}
                  </span>
                  <span class="has-text-default is-size-7" v-if="utilisateur.estTechnicien">
                    <br/>{{ $t('detailUtilisateur.technicien') }}
                  </span>
                  <span class="has-text-default is-size-7" v-if="utilisateur.estAfficheur">
                    <br/>{{ $t('detailUtilisateur.afficheur') }}
                  </span>
                  <span class="has-text-default is-size-7" v-if="utilisateur.responsableBail">
                    <br/>{{ $t('detailUtilisateur.responsableBail') }}
                  </span>
                </div>
              </div>
            </article>
            <div class="columns mgt-20px">
              <div class="column is-3">
                <p class="has-text-link has-text-weight-bold">
                  {{ $t('detailUtilisateur.informations') }}
                </p>
              </div>
              <div class="column is-3">
                <p class="has-text-link has-text-weight-bold">
                  {{ $t('detailUtilisateur.role') }}
                </p>
              </div>
            </div>
            <div class="columns">
              <div class="column is-3">
                <div class="columns is-multiline">
                  <div class="column is-12">
                    <b-field :label="$t('detailUtilisateur.email')"
                             custom-class="is-italic has-text-weight-normal">
                      <p class="has-text-weight-bold">{{ this.utilisateur.email }}</p>
                    </b-field>
                  </div>
                  <div class="column is-12">
                    <b-field :label="$t('detailUtilisateur.telephone')"
                             custom-class="is-italic has-text-weight-normal">
                      <p class="has-text-weight-bold">{{ this.utilisateur.telephone }}</p>
                    </b-field>
                  </div>
                  <div class="column is-12">
                    <b-field :label="$t('detailUtilisateur.agenceRattachement')"
                             custom-class="is-italic has-text-weight-normal">
                      <p class="has-text-weight-bold">
                        {{ this.utilisateur.agence.libelleSociete + ' - ' +
                      this.utilisateur.agence.libelleAgence}}</p>
                    </b-field>
                  </div>
                </div>
              </div>
              <div class="column is-3">
                <div class="columns is-multiline">
                  <div class="column is-12 ">
                    <b-field :label="$t('detailUtilisateur.roleDetail')"
                             custom-class="is-italic has-text-weight-normal">
                    </b-field>
                    <div v-for="(role, index) in utilisateur.objetsRoles" :key="index">
                      <b-field>
                        <router-link-blank
                          :to="{ name: 'c.parametrage.roles', params: { id: role.id} }"
                          :message="role.displayName"
                          :classComposant="'has-text-weight-bold is-underline'">
                        </router-link-blank>
                        <b-icon icon="open-in-new" type="is-default" size="is-small"
                                class="mgt-5px"></b-icon>
                      </b-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="listesAgences">
          <liste-agences :societe="utilisateur" :editable="false" class="mgt-20px">
          </liste-agences>
        </div>
        <div id="listeServices">
          <liste-services :utilisateur="utilisateur" class="mgt-20px">
          </liste-services>
        </div>
      </div>
      <div class="column is-2">
        <dots-menu :steps="steps" class="is-fixed"></dots-menu>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from 'vue-avatar';
import DotsMenu from '@/components/general/dotsMenu';
import listeAgences from '@/components/parametrage/societes/listeAgences';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { COLLABORATEURS } from '@/configuration/general/permissionsParametrageConf';
import { LISTE_PROFIL } from '@/configuration/parametrage/utilisateurConf';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import { createNamespacedHelpers } from 'vuex';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import listeServices from '@/components/parametrage/collaborateur/listeServices';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'informationCollaborateur',
  components: {
    Avatar,
    DotsMenu,
    listeAgences,
    routerLinkBlank,
    listeServices,
  },
  props: {
    utilisateur: {
      required: true,
      type: Object,
    },
    logo: {
      required: false,
    },
  },
  data() {
    return {
      permsCollaborateurs: COLLABORATEURS,
      steps: [
        {
          name: this.$i18n.t('detailUtilisateur.collaborateur'),
          ref: '#collaborateur',
          active: true,
        },
        {
          name: this.$i18n.t('societes.listeAgence'),
          ref: '#listesAgences',
          active: false,
        },
        {
          name: this.$i18n.t('detailUtilisateur.listeService'),
          ref: '#listeServices',
          active: false,
        },
      ],
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    getUsername() {
      return nomPrenomGetter(this.utilisateur);
    },
    getCiviliteLibelle() {
      const civilite = this.civilites.find((civilite) => {
        return civilite.id === this.utilisateur.civiliteId;
      });
      return civilite ? civilite.libelle : '';
    },
    civilites() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.civilite);
    },
  },
  methods: {
    getPosteLibelle(profilUtilisateur) {
      return LISTE_PROFIL.find((profil) => {
        return profil.code === profilUtilisateur;
      }).libelle;
    },
  },
};
</script>

<style scoped>

</style>
